import React from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';

export const SPDxPlot = ({ wavelength, spd, inputType }) => {
  const maxYAxisRange = spd.length !== 0 ? Math.max(...spd) : 1;
  let yAxisMaxRange = 1;
  let yAxisStep = 0.2;

  if (maxYAxisRange < 0.1) {
    yAxisMaxRange = maxYAxisRange + 0.01;
    yAxisStep = 0.01;
  } else if (maxYAxisRange > 10) {
    yAxisMaxRange = maxYAxisRange + 5;
    yAxisStep = 5;
  } else if (maxYAxisRange > 5) {
    yAxisMaxRange = maxYAxisRange + 2;
    yAxisStep = 1;
  } else if (maxYAxisRange > 1) {
    yAxisMaxRange = maxYAxisRange + 0.5;
    yAxisStep = 0.5;
  } else {
    yAxisMaxRange = 1;
    yAxisStep = 0.2;
  }

  return (
    <div>
      <Plot
        useResizeHandler={true}
        style={{ width: '100%' }}
        data={[
          {
            name: 'SPD Value',
            x: wavelength,
            y: spd,
            type: 'scatter',
            mode: 'lines+points',
            hovertemplate: '%{y:.4f}',
            marker: { color: 'red' },
          },
        ]}
        layout={{
          //width: 800,
          height: 200,
          legend: {
            xanchor: 'center',
            yanchor: 'top',
            y: -0.2,
            x: 0.5,
            orientation: 'h',
          },
          margin: {
            l: 60,
            r: 30,
            b: 60,
            t: 20,
            pad: 0,
          },
          xaxis: {
            title: {
              text: 'Wavelength (nm)',
            },
            tick0: 380,
            dtick: 50,
            range: [380, 780],
            tickwidth: 2,
            mirror: 'ticks',
            linewidth: 2,
            linecolor: 'black',
            fixedrange: true,
          },
          yaxis: {
            showline: true,
            title: {
              text: inputType === 'library' ? 'Relative Power' : 'SPD Value',
            },
            // tickformat: '.01f',
            tick0: 0,
            dtick: yAxisStep,
            range: [0, yAxisMaxRange],
            mirror: 'ticks',
            linewidth: 2,
            linecolor: 'black',
            fixedrange: true,
          },
        }}
        config={{
          displaylogo: false,
          modeBarButtons: [['toImage']],
          responsive: true,
          toImageButtonOptions: {
            format: 'png', // one of png, svg, jpeg, webp
            filename: 'Equal Luminous Flux',
            height: 700,
            width: 900,
            scale: 1.5, // Multiply title/legend/axis/canvas sizes by this factor
          },
        }}
      />
    </div>
  );
};

SPDxPlot.propTypes = {
  wavelength: PropTypes.array,
  spd: PropTypes.array,
  inputType: PropTypes.string,
};
